export const GALLERY_ITEM_TYPE_ARTIST_VIDEO = 'artist_video'
export const GALLERY_ITEM_TYPE_VIEW_IN_A_ROOM_IMAGE = 'view_in_a_room_image'
export const GALLERY_ITEM_TYPE_IMAGE = 'image'
export const GALLERY_ITEM_TYPE_ADDITIONAL_IMAGE = 'additional_image'
